import { Roles } from "../../../core/enums/roles";

export interface NavItem {
  id?: string;
  title: string;
  icon?: string;
  link?: string;
  badge?: string;
  roles?: string[];
  children?: NavItem[];
  isOpen?: boolean;
}

export const NAVBAR_CONFIG: NavItem[] = [
  // --- MERCHANT & SUPER ADMIN ITEMS ---
  {
    id: "dashboard",
    title: "Dashboard",
    icon: "dashboard-line",
    link: "/dashboard",
    roles: [Roles.SUPER_ADMIN, Roles.MERCHANT],
  },

  {
    id: "stations",
    title: "Stations",
    icon: "charging-pile-line",
    link: "/stations",
    roles: [Roles.SUPER_ADMIN, Roles.MERCHANT],
  },
  {
    id: "sessions",
    title: "Sessions",
    icon: "history-line",
    link: "/sessions",
    roles: [Roles.SUPER_ADMIN, Roles.MERCHANT],
  },
  {
    id: "coupons",
    title: "Coupons",
    icon: "price-tag-3-line",
    link: "/coupons",
    roles: [Roles.SUPER_ADMIN, Roles.MERCHANT],
  },
  {
    id: "payouts",
    title: "Payouts",
    icon: "money-dollar-circle-line",
    link: "/payouts/list",
    roles: [Roles.SUPER_ADMIN, Roles.MERCHANT],
  },
  {
    id: "accounts",
    title: "Accounts",
    icon: "account-box-line",
    link: "/accounts",
    roles: [Roles.SUPER_ADMIN, Roles.MERCHANT],
  },
  // --- SUPER ADMIN ONLY ITEMS ---
  {
    id: "insights",
    title: "Revenue Insights",
    icon: "bar-chart-line",
    roles: [Roles.SUPER_ADMIN],
    link: "/insights/revenue",

    // children: [
    //   {
    //     id: "revenue-insights",
    //     title: "Revenue Insights",
    //     icon: "money-dollar-box-line",
    //     link: "/insights/revenue",
    //     roles: [Roles.SUPER_ADMIN],
    //   }
    // ],
  },
  {
    id: "transactions",
    title: "Transactions",
    icon: "currency-line",
    link: "/transactions",
    roles: [Roles.SUPER_ADMIN],
  },
  {
    id: "pending-entities",
    title: "Pending Entities",
    icon: "file-list-3-line",
    link: "/pending-entities",
    roles: [Roles.SUPER_ADMIN],
  },
  {
    id: "system-users",
    title: "System Users",
    icon: "user-settings-line",
    link: "/system-users",
    roles: [Roles.SUPER_ADMIN],
  },
  {
    id: "configurations",
    title: "Configurations",
    icon: "settings-4-line",
    roles: [Roles.SUPER_ADMIN],
    children: [
      {
        id: "connector-types",
        title: "Connector Types",
        icon: "plug-line",
        link: "/configurations/connector-types",
        roles: [Roles.SUPER_ADMIN],
      },
      {
        id: "amenities",
        title: "Amenities",
        icon: "hotel-bed-line",
        link: "/configurations/amenities",
        roles: [Roles.SUPER_ADMIN],
      },
    ],
  },

  // {
  //   id: "settings",
  //   title: "Settings",
  //   icon: "moon-line",
  //   link: "/settings/preference",
  //   roles: [Roles.SUPER_ADMIN, Roles.MERCHANT],
  // },
];

export const fetchNavConfigFromServer = (): Promise<NavItem[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(NAVBAR_CONFIG);
    }, 500);
  });
};
